module.exports = __webpack_public_path__ + "static/media/iconFriendsActive.8e14d3de.svg";